// src/components/MvCountDown/index.js

module.exports = require('./MvCountDown.vue')